/**
 * TimelineTabs
 * @description Web component used to create sliders, configurable with data-options attribute.
 * @documentation https://swiperjs.com/swiper-api
 */

import { Swiper } from 'swiper';
import { A11y, Navigation, Pagination, Scrollbar, Autoplay, Parallax } from 'swiper/modules';

class TimelineTabs extends HTMLElement {
  constructor() {
    super();
    this.swiper = this.querySelector('[data-swiper]');
    const menu = JSON.parse(this.swiper.dataset.menu);

    // Call swiper with selected swiper element and options
    this.swiperInstance = new Swiper(this.swiper, {
      modules: [A11y, Navigation, Pagination, Scrollbar, Autoplay, Parallax],
      threshold: 10,
      speed: 500,
      parallax: true,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return (
            '<span  before=" " class="' +
            className +
            ' w-fit h-fit z-[1] block p-2 text-xs lg:text-base relative !opacity-100 cursor-pointer bg-transparent before:bg-primary before:h-2 before:w-2 before:content-[attr(before)] before:top-[-4px] before:absolute before:block before:rounded-full before:translate-x-[-50%] before:left-1/2">' +
            menu[index] +
            '</span>'
          );
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      ...JSON.parse(this.swiper.dataset?.options || '{}'),
    });

    /**
     * Listen to extra events when in Shopify editor
     */
    if (!Shopify.designMode) return;

    ['shopify:section:load', 'shopify:block:select', 'shopify:block:deselect'].forEach((type) => {
      window.addEventListener(type, (event) => {
        this.swiperInstance.update();
        this.swiperInstance.navigation?.init();
        this.swiperInstance.navigation?.update();
        if (type !== 'shopify:section:load') this.handleBlockSelect(event);
      });
    });
  }

  /**
   * Handles the theme editor block change/edit event
   * @param {Object} event
   */
  handleBlockSelect(event) {
    // Check if the slide index is set
    if (!('swiperSlideIndex' in event.target.dataset)) return;

    // Set the slide index based on loop settings or not
    let swipeToSlideIndex = parseInt(event.target.dataset.swiperSlideIndex) - 1;
    if (this.swiperInstance.params.loop) {
      swipeToSlideIndex = parseInt(event.target.dataset.swiperSlideIndex) + 1;
    }

    // Slide to slide based on the data attribute from the target
    const sliderToUpdate = event.target.closest('[data-swiper]');
    sliderToUpdate.swiper.slideTo(swipeToSlideIndex, 1000);
  }
}

customElements.define('timeline-tabs', TimelineTabs);
